import axios from 'axios';
import errorManager from '@/rollbar.js';

const requestPost = function () {
  if (confirm(i18nJS.cp1.confirm_edit)) {
    Loader.show();
    const url = $(this).attr('href');
    axios({
      method: 'post',
      url: url,
      data: { format: 'json' },
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-Token': $.rails.csrfToken(),
      },
    })
      .then((response) => {
        let class_disaled = '#cp1_' + response.data.id;
        $(class_disaled).addClass('disabled');
        Utils.appendToFlash('success', i18nJS.cp1.success_edit);
      })
      .catch(() => {
        Utils.appendToFlash('error', i18nJS.cp1.fail_edit);
      })
      .then(() => {
        Loader.hide();
      });
  }
};

const initListener = () => {
  () => {
    return window.i18nJS;
  };
  $(document).on('click', '.flux--cancel:not(.disabled)', requestPost);
};

const init = () => {
  try {
    initListener();
  } catch (e) {
    errorManager(e);
  }
};

window.Cp1s = {
  init: init,
};
